/* eslint-disable import/no-unresolved */
import React, { useRef, useState, useEffect } from 'react';
import { motion } from 'framer-motion';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css/bundle';
import 'swiper/css/pagination';
import 'swiper/css/grid';
import 'swiper/css/navigation';
import { Pagination, Autoplay } from 'swiper';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import { chunk, isEmpty, kebabCase } from 'lodash';
import SwiperNavigationButton from '../layouts/SwiperNavigationButton';
import BoxedContainer from '../layouts/BoxedContainer';

export default function DesktopPartnersCards({ data }) {
  const sliderRef = useRef();
  const [swiper, setSwiper] = useState(null);
  const [currSlide, setCurrSlide] = useState(1);
  const handleClickNext = () => swiper?.slideNext();
  const handleClickPrev = () => swiper?.slidePrev();
  useEffect(() => {
    setCurrSlide(0);
  }, []);

  const activeSlideNumber = currSlide;

  const breakpoints = {
    0: {
      slidesPerView: 1,
      slidesPerGroup: 1,
    },
    320: {
      slidesPerView: 1.5,
      slidesPerGroup: 1,
    },
    640: {
      slidesPerView: 1.5,
      slidesPerGroup: 1,
    },
    768: {
      slidesPerView: 2,
      slidesPerGroup: 1,
    },
    992: {
      slidesPerView: 1,
      slidesPerGroup: 1,
    },
    1100: {
      slidesPerView: 1,
      slidesPerGroup: 1,
    },
    1368: {
      slidesPerView: 1,
      slidesPerGroup: 1,
    },
  };

  const chunkedArr = chunk(data, 10);

  return (
    <div className="lg:pt-[42px] pt-[30px] lg:block hidden">
      <motion.div
        initial={{ opacity: 0, y: 50 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.4, delay: 0.3 }}
        viewport={{ once: true }}
        className=" relative">
        <Swiper
          ref={sliderRef}
          breakpoints={breakpoints}
          onSwiper={setSwiper}
          spaceBetween={20}
          loop
          autoplay={{
            delay: 3000,
          }}
          pagination={{
            type: 'custom',
          }}
          modules={[Pagination, Autoplay]}
          onSlideChange={(_swiper) => setCurrSlide(_swiper.realIndex)}
          className="h-auto">
          {isEmpty(chunkedArr) ||
            chunkedArr.map((item, index) => {
              const chunkedArrCard = chunk(item, 5);
              return (
                <SwiperSlide key={index}>
                  <div
                    className="flex flex-col 3xl:gap-y-[30px] gap-y-[20px] 3xl:px-[80px]
                    px-[60px]">
                    <div className="flex flex-row gap-x-[20px] 3xl:pl-[100px] pl-[25px]">
                      {isEmpty(chunkedArrCard[0]) ||
                        chunkedArrCard[0].map((cardItem, ind) => (
                          <div
                            className={`3xl:!h-[180px] !h-[150px] skew-x-[20deg] overflow-hidden
                            bg-bg-1 flex flex-col items-center justify-around w-[calc(20%-16px)] 
                            py-4 xl:py-6
                            ${kebabCase(cardItem.content.title)}`}>
                            {isEmpty(cardItem.content.title) || (
                              <div
                                className="-skew-x-[20deg] relative text-[12px] xl:text-[15px] 
                             2xl:-left-4 text-[#666] font-roboto-condensed-regular mt-0 mb-auto">
                                {cardItem.content.title}
                              </div>
                            )}
                            <a
                              href={cardItem.content.link.url}
                              key={ind}
                              aria-label={cardItem.content.title}
                              target="_blank"
                              rel="noreferrer"
                              className="!w-[50%] min-h-[50px] !h-auto flex items-center">
                              <LazyLoadImage
                                src={cardItem.content.image.url}
                                alt={cardItem.content.title}
                                className="max-h-[80px] !object-contain my-auto
                                duration-400 ease-in-out -skew-x-[20deg] transition-all"
                              />
                            </a>
                          </div>
                        ))}
                    </div>
                    <div className="flex flex-row gap-x-[20px] 3xl:pr-[100px] pr-[25px]">
                      {isEmpty(chunkedArrCard[1]) ||
                        chunkedArrCard[1].map((cardItem, ind) => (
                          <div
                            className={`3xl:!h-[180px] !h-[150px] skew-x-[20deg] overflow-hidden
                            bg-bg-1 flex flex-col items-center justify-around w-[calc(20%-16px)] 
                            py-4 xl:py-6
                            ${kebabCase(cardItem.content.title)}`}>
                            {isEmpty(cardItem.content.title) || (
                              <div
                                className="-skew-x-[20deg] relative text-[12px] xl:text-[15px] 
                             2xl:-left-4 text-[#666] font-roboto-condensed-regular mt-0 mb-auto">
                                {cardItem.content.title}
                              </div>
                            )}
                            <a
                              href={cardItem.content.link.url}
                              key={ind}
                              aria-label={cardItem.content.title}
                              target="_blank"
                              rel="noreferrer"
                              className="!w-[50%] min-h-[50px] !h-auto flex items-center">
                              <LazyLoadImage
                                src={cardItem.content.image.url}
                                alt={cardItem.content.title}
                                className="max-h-[80px] !object-contain my-auto
                                duration-400 ease-in-out -skew-x-[20deg] transition-all"
                              />
                            </a>
                          </div>
                        ))}
                    </div>
                  </div>
                </SwiperSlide>
              );
            })}
        </Swiper>
      </motion.div>

      {data.length > 10 && (
        <BoxedContainer>
          <div className="flex flex-row items-center gap-x-10 3xl:pt-[60px] lg:pt-[40px] pt-[25px]">
            <div className="relative flex flex-row gap-x-4">
              <SwiperNavigationButton
                type="prev"
                clickHandler={handleClickPrev}
                icon="black-prev-arrow"
                className="partners-prev-button"
              />
              <SwiperNavigationButton
                type="next"
                clickHandler={handleClickNext}
                icon="black-next-arrow"
                className="partners-next-button"
              />
            </div>
            <p
              className="text-primary font-roboto-regular md:text-[23px] text-[18px] md:leading-8
              leading-7">
              {activeSlideNumber + 1} - {Math.ceil(data.length / 10)}
            </p>
          </div>
        </BoxedContainer>
      )}
    </div>
  );
}
